module.exports = __webpack_public_path__ + "static/fonts/ionicons.143146f.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/view-design/src/styles/common/iconfont/fonts/ionicons.woff2?v=3.0.0
// module id = 569
// module chunks = 8